// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PageCanvas__overlayClass___2fbb8{position:absolute;-moz-user-select:none;-webkit-user-select:none;-o-user-select:none;user-select:none}.PageCanvas__overlayClass___2fbb8,.PageCanvas__parent___3q0oQ{height:100%;touch-action:manipulation;width:100%}.PageCanvas__overlayComponentContainer___3VZrA{left:0;position:absolute;top:0}.PageCanvas__fullPageGeometry___1QVxf{height:100%;width:100%}.PageCanvas__noPointerEvents___u34Vq *{pointer-events:none!important}", ""]);
// Exports
exports.locals = {
	"overlayClass": "PageCanvas__overlayClass___2fbb8",
	"parent": "PageCanvas__parent___3q0oQ",
	"overlayComponentContainer": "PageCanvas__overlayComponentContainer___3VZrA",
	"fullPageGeometry": "PageCanvas__fullPageGeometry___1QVxf",
	"noPointerEvents": "PageCanvas__noPointerEvents___u34Vq"
};
module.exports = exports;
